import { DELETE_FORM_LINK_SUCCESS } from './';

export default payload => dispatch =>
  dispatch({
    type: DELETE_FORM_LINK_SUCCESS,
    payload,
  });
